import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from "../components/ui/accordion";
import { Section, PageHero } from "../components/site/section";
import { PageCta } from "../components/site/page-cta";

const faqSections = [
    {
        title: "Learn More About Violerts",
        faqs: [
            {
                q: "What is Violerts?",
                a: "Violerts is a property compliance monitoring tool that provides real-time alerts on complaints, violations, and work applications related to your property. It also delivers detailed property reports to keep you informed.",
            },
            {
                q: "Where does Violerts collect property compliance data from?",
                a: "Violerts gathers property data directly from official NYC agencies such as the Department of Buildings (DOB), Housing Preservation and Development (HPD), Fire Department of New York (FDNY), Department of Transportation (NYC DOT), and New York State databases.",
            },
            {
                q: "Can I search for any property on Violerts?",
                a: "Property searches on Violerts are limited to the New York City metropolitan area, including Manhattan, Queens, Brooklyn, the Bronx, and Staten Island.",
            },
            {
                q: "What if I search for a property in NYC and data is unavailable?",
                a: "If you encounter an error while searching for an NYC property, please report the missing property using the button on the page or contact us via the chatbot. Our team will investigate the issue and provide an update once it is resolved.",
            },
        ],
    },
    {
        title: "Learn More About Property Alerts and Notifications",
        faqs: [
            {
                q: "What types of alerts will I receive?",
                a: "You will receive real-time alerts in your portfolio and via email when Violerts detects new violations, complaints, or work.",
            },
            {
                q: "Can I sign up for notifications to keep track of any changes to my property?",
                a: "You can receive notifications when Violerts detects any change in violations, complaints, or work orders.",
            },
            {
                q: "How do I set up and manage property alert notifications?",
                a: "After setting up an account, you can add properties to your portfolio by clicking the “Add Property” button on the property search page or within your dashboard. Once added, you can manage notifications from the Notification Settings section in your portfolio, where you can customize alert frequency and preferences for each property.",
            },
        ],
    },
    {
        title: "Learn More About Reports & Integrations",
        faqs: [
            {
                q: "What is the Comprehensive Property Report (CPR)?",
                a: "The CPR is a detailed, on-demand report ($600) that brings together critical information about an NYC property in one place. From ownership and zoning to building systems, occupancy, violations, filings, and historical records, it provides a comprehensive snapshot for due diligence and informed decision-making.",
            },
            {
                q: "What is the Property Status Report (PSR)?",
                a: "The PSR is a recurring report ($200) designed to keep you informed about the current status of your property. It summarizes recent violations, permits, complaints, filings, compliance activity, upcoming deadlines, and other important changes so you can quickly identify what needs attention.",
            },
            {
                q: "How do I request a CPR or PSR?",
                a: "Use the Request buttons on the Reports page, select “Comprehensive Property Report Request” or “Property Status Report Request” as the category on the Contact page, or email us directly. You can also request either report under the Documents section of each property in your dashboard. ",
            },
            {
                q: "What is the Airtable integration?",
                a: "The Airtable integration syncs live violation, complaint and permit data directly into your Airtable bases, so your team can build views, dashboards and workflows on top of Violerts data. Records update automatically as agency data changes — no manual CSV imports. It is available on the Enterprise plan.",
            },
            {
                q: "How do I set up the Airtable integration?",
                a: "Reach out through the Contact page and select “Airtable Integration Request” as the category. Our team will help you connect your portfolio, map the data into your bases, and configure automatic updates.",
            },
        ],
    },
    {
        title: "Learn More About My Account",
        faqs: [
            {
                q: "How do I create an account?",
                a: "You can create a Violerts account by clicking Sign Up under the profile icon in the upper-right corner of the homepage or dashboard. From there, provide your email, name, password, and phone number.",
            },
            {
                q: "Is my data secure with Violerts?",
                a: "Yes. Violerts takes your privacy seriously and uses industry-standard encryption to protect your information, including email addresses, phone numbers, and payment details. For more details, please review our Privacy Policy.",
            },
        ],
    },
    {
        title: "Learn More About Pricing & Billing",
        faqs: [
            {
                q: "What plans does Violerts offer?",
                a: "Violerts offers a Free plan ($0), Starter ($75/mo), Pro ($120/mo), Business ($199/mo), and custom Enterprise pricing. Visit the Pricing page for the full breakdown of what each plan includes.",
            },
            {
                q: "Do you offer yearly billing?",
                a: "Yes. Every paid plan can be billed monthly or yearly, and paying yearly saves you 10%.",
            },
            {
                q: "What does the “SMS Alerts Add On” do?",
                a: "The SMS Alerts Add On is a $19.99/month add-on that delivers alerts to your phone by text message in addition to dashboard and email notifications.",
            },
            {
                q: "Can I get started for free?",
                a: "Yes. The Free plan costs nothing and lets you start monitoring NYC properties. Paid plans add larger portfolios, SMS delivery, reports, and integrations as your needs grow.",
            },
        ],
    },
    {
        title: "Learn More About Support & Contact",
        faqs: [
            {
                q: "How can I contact Violerts for support?",
                a: "The Violerts team is here to help. You can reach us through the chatbot in the bottom-right corner of the page, email us at admin@violerts.com, or call us at (212) 401-6011. Whether you need help adding a property to your portfolio, have questions about using Violerts, or want to report an issue, our team is ready to assist you.",
            },
        ],
    },
];
function Faqs() {
    return (<>
      <PageHero title="Common questions" description="Straight answers on coverage, data lag, pricing and how resolution support works."/>
      <Section>
        <div className="mt-10 max-w-3xl space-y-12">
          {faqSections.map((faqSection) => (<div key={faqSection.title}>
              <h3 className="font-display text-2xl font-semibold text-foreground md:text-3xl">
                {faqSection.title}
              </h3>
              <Accordion type="single" collapsible className="mt-5">
                {faqSection.faqs.map((faq) => (<AccordionItem key={faq.q} value={faq.q}>
                    <AccordionTrigger className="text-left text-base font-semibold">
                      {faq.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                      {faq.a}
                    </AccordionContent>
                  </AccordionItem>))}
              </Accordion>
            </div>))}
        </div>
      </Section>
      <PageCta />
    </>);
}

export default Faqs;
